import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { abstractChart } from '../abstractChart';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  standalone: false,
})
export class LineChartComponent extends abstractChart {
  @ViewChild('chart') chart: ElementRef<HTMLCanvasElement> | undefined;
  @Input() label: string = '';

  constructor() {
    super('line', false);
  }

  getLabel(): string {
    return this.label;
  }

  getGraph(): ElementRef<HTMLCanvasElement> | undefined {
    return this.chart;
  }
}
